import React from 'react';

/*
 *  @Description:   Stateless component that renders an Sort Descending Triangle.
 */

const SortAsc = ( props ) => {

    return (
        <g>
            <path d="m12 20 5-6h-10l2.5 3z"/>
        </g>

    )

};

export default SortAsc;

